import { type Dispatch, type SetStateAction, useEffect } from 'react'

const NAVBAR_OFFSET = 150 // approx header height + buffer

export const useIntersectionObserver = (
  setActiveId: Dispatch<SetStateAction<string>>,
  headingIds: string[]
) => {
  useEffect(() => {
    if (headingIds.length === 0) return

    const isAtBottom = () =>
      window.scrollY + window.innerHeight >=
      document.documentElement.scrollHeight - 80

    const getActiveId = (): string => {
      if (isAtBottom()) return headingIds[headingIds.length - 1]

      const scrollY = window.scrollY + NAVBAR_OFFSET

      let active = headingIds[0]

      for (const id of headingIds) {
        const el = document.getElementById(id)

        if (el && el.getBoundingClientRect().top + window.scrollY <= scrollY) {
          active = id
        }
      }

      return active
    }

    const onScroll = () => setActiveId(getActiveId())

    // Set immediately on mount
    setActiveId(getActiveId())

    window.addEventListener('scroll', onScroll, { passive: true })

    return () => window.removeEventListener('scroll', onScroll)
    // Re-run when the set of headings changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setActiveId, headingIds.join(',')])
}
